<template>
  <modal
    name="create-client"
    class="envivo-modal"
    @before-open="$h.toggleHtmlScroll"
    @before-close="$h.toggleHtmlScroll"
    @closed="closedCallback(createdClient)"
    transition="pop-out"
    height="auto"
    adaptive
    :maxWidth="800"
    width="90%"
    scrollable
  >
    <div class="modal-wrapper">
      <div class="modal-title">{{ $t("titles.createClient") }}</div>
      <div class="relative">
        <div class="modal-content">
          <create-edit-client-form
            @afterCreate="
              (client) => {
                afterCreate(client);
              }
            "
            hideSubmitBtn
          ></create-edit-client-form>
        </div>
        <div class="modal-buttons">
          <a class="v1 simple" @click="$modal.hide('create-client')">{{ $t("actions.cancel") }}</a>
          <v-button primary @click.native="$eventbus.$emit('submitClient', true)">{{
            $t("actions.createClient")
          }}</v-button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import CreateEditClientForm from "../forms/CreateEditClientForm";

export default {
  name: "CreateClientModal",
  components: { CreateEditClientForm },
  props: {
    closedCallback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      createdClient: null,
    };
  },
  methods: {
    afterCreate(client) {
      this.createdClient = client;
      this.$modal.hide("create-client");
    },
  },
};
</script>

<style lang=""></style>
